// import compileVariableUtil from '../../../../static/js/compileVariableUtil'
// import templateUtil from '../templateUtil'
import objectUtil from '../../../../static/js/objectUtil'

export default function (validateItem, formItem, fCreateApi) {
  validateItem.type = null
  validateItem.pattern = null

  if (!validateItem.parameter) {
    console.error('error:rule.parameters is require!')
    return
  }

  // console.log("validateConverterUtil.converterAdapter:dynamicRange",
  //   validateItem);
  validateItem.trigger = 'blur'
  validateItem.validator = (rule, value, callback) => {
    var formData = fCreateApi.getFormData()

    if (value === undefined) {
      if (callback) callback()
      return
    }

    var isNumber = typeof value === 'number'
    var isDate = value && typeof value === 'object' && value.getTime

    // console.log("validateConverterUtil.converterAdapter:dynamicRange2",
    //   typeof value);
    // 配置模板，减少请求数量
    if (validateItem.parameter) {
      var validateFlag = true
      var msg = validateItem.message
      if (!msg) msg = '超出限定范围'

      if (validateItem.parameter.hasOwnProperty('maxField')) {
        var maxField = validateItem.parameter.maxField
        var maxValue = objectUtil.getValueByPath(formData, maxField)
        if (isNumber) maxValue = new Number(maxValue)
        else if (isDate) {
          value = value.getTime()
          maxValue = maxValue.getTime()
        }
        if (value > maxValue) {
          validateFlag = false
        }
      }

      if (validateItem.parameter.hasOwnProperty('minField')) {
        var minField = validateItem.parameter.minField
        var minValue = objectUtil.getValueByPath(formData, minField)
        if (isNumber) minValue = new Number(minValue)
        else if (isDate) {
          value = value.getTime()
          minValue = minValue.getTime()
        }
        if (value < minValue) {
          validateFlag = false
        }
      }

      if (validateFlag) {
        if (callback) callback()
      } else {
        if (callback) callback(new Error(msg))
      }
    }

    // console.log("validateConverterUtil.converterAdapter:validateItem",
    //   validateItem);
  }
}
